import { useEffect, useState } from "react"
import {
  stages,
  useAppNotificationStore,
  usePaymentStore,
  useProfileStore,
  Form,
  ActivateProfileCredentialsInterface,
} from "stores"
import { Button, H4, P1 } from "components"
import { illustrations } from "assets"

export const AdmissionStatus: React.FC<{}> = () => {
  const [form] = useState(new Form<ActivateProfileCredentialsInterface>())
  const { toast, setDashboardContext } = useAppNotificationStore()
  // const [admission, setAdmission] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const { profile, printAdmissionLetter } = useProfileStore()

  const { initiatePayment } = usePaymentStore()

  const handleInitiatePayment = async () => {
    try {
      form.submitting(true)
      await initiatePayment({ payType: "AcceptanceFee" }).then((resp) => {
        if (resp.isSuccessful === true) {
          toast.success(resp.message)
          window.location.href = resp.data.paymentUrl
        } else {
          toast.error(resp.message)
        }
      })
    } catch (error) {
      form.submitting(false)
    }
  }
  const printLetter = async () => {
    try {
      setIsLoading(true)
      await printAdmissionLetter()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    setDashboardContext("Admission Status")
  }, [setDashboardContext])

  const details: { key: string; value: string }[] = [
    { key: "Full name", value: `${profile?.surname} ${profile?.firstname} ${profile?.othername}` },
    // { key: "Mode of Entry", value: "UTME" },
    { key: "Session", value: "2024/2025" },
    { key: "Department", value: `${profile?.department}` },
    // { key: "Faculty", value: "Communication and Information Science" },
    { key: "Program Award", value: `${profile?.programmeLevel}` },
  ]

  return (
    <>
      <H4 className="font-semibold text-accentText mb-8 block lg:hidden">
        Admission Status
      </H4>
      {profile?.nextStage === stages.Admitted ? (
        <div className="flex flex-col gap-10 bg-pryExtraLight">
          <div className="px-5 lg:px-20 flex flex-col items-center gap-10 pt-8 pb-10">
            <div className="px-5 lg:px-0 flex flex-col items-center gap-6">
              <img
                src={illustrations.AchievementBadge}
                alt="Achievement badge"
              />
              <H4 className="font-semibold text-accentText text-center">
                Congratulations, {profile?.firstname} {profile?.surname}.
              </H4>
              <p className="text-xl text-accentText text-center">
                {/* You have been offered admission for a 5-year FIrst Degree
                Program. See Details Below and proceed to pay your acceptance
                fees. */}
                You have been offered admission.
              </p>
            </div>

            {/* Table */}
            <div className="px-4 lg:px-12 py-4 w-full bg-white flex flex-col gap-9">
              <P1 className="py-3 px-4 border-b-4 border-pryBase text-pryBase font-medium w-full lg:w-max">
                Admission Details
              </P1>
              <div className="w-full py-3 px-0 lg:px-4">
                {details
                  .filter((i) => i.value)
                  .map((detail, index) => (
                    <div className="flex gap-2 lg:gap-10 py-1">
                      <P1 className="text-accentGrey1 py-4 font-medium min-w-[130px]">
                        {detail.key}
                      </P1>
                      <P1 className="text-accentText py-4 font-medium">
                        {detail.value}
                      </P1>
                    </div>
                  ))}
              </div>

              <Button
                color="primary"
                type="button"
                title="Pay Acceptance Fees"
                className="w-full lg:w-max"
                disabled={form.isSubmitting}
                submitting={form.isSubmitting ? "true" : "false"}
                onClick={handleInitiatePayment}
              >
                Pay Acceptance Fees
              </Button>

              <Button
                color="primary"
                type="submit"
                title="Print Admission Letter"
                className="w-full lg:w-max"
                submitting={isLoading ? "true" : "false"}
                disabled={isLoading}
                onClick={printLetter}
              >
                Print Admission Letter
              </Button>
              <a
  href={`https://lodlc.lautech.edu.ng/pay/#/techfee/${profile?.profileId}`}
  target="_blank"
  rel="noopener noreferrer"
  className="w-full lg:w-max"
  title="Digital Access"
>
  <Button
    color="primary"
    type="submit"
    className="w-full lg:w-max"
    submitting={isLoading ? "true" : "false"}
    disabled={isLoading}
  >
    Digital Access Fee
  </Button>
</a>

            </div>
          </div>
        </div>
      ) : (profile as unknown as any)?.nextStage === "IsRejected" ? (
        <div className="flex flex-col gap-10 bg-[#F9FAFB]">
          <div className="px-5 lg:px-20 flex flex-col items-center gap-10 pt-8 pb-10">
            <div className="flex flex-col items-center gap-6">
              <img
                src={illustrations.NoData}
                alt="Achievement badge"
              />
              <H4 className="font-semibold text-accentText text-center">
                Hello, {profile?.firstname} {profile?.surname}
              </H4>
              <p className="text-xl text-accentText text-center">
                We regret to inform you that your admission has been rejected.
                We encourage you to try again next year.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-10 bg-[#F9FAFB]">
          <div className="px-5 lg:px-20 flex flex-col items-center gap-10 pt-8 pb-10">
            <div className="flex flex-col items-center gap-6">
              <img
                src={illustrations.NoData}
                alt="Achievement badge"
              />
              <H4 className="font-semibold text-accentText text-center">
                Hello, {profile?.firstname} {profile?.surname}
              </H4>
              <p className="text-xl text-accentText text-center">
                Sorry, you have not been offered admission yet. Please, check
                back later.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
